const { decoratorOptions } = require("./configParams");
const { initializePerformanceTheme, receivePerformanceItem } = require("./initialize");

exports.decoratorOptions = decoratorOptions;
exports.initializePerformanceTheme = initializePerformanceTheme;
exports.receivePerformanceItem = receivePerformanceItem;
